import { useLocation } from "react-router-dom";
import SEOHead from "./SEOHead";
import { generateTournamentStructuredData } from "./StructuredData";
import { useTournamentSlug } from "../../context/TournamentRouteContext";
import { prerenderTournamentForPath } from "../../prerender/pageData";
import { subpageMeta } from "../../prerender/tournamentSubpages";
import { tournamentPath } from "../../utility/tournamentUrls";

const TournamentSubpageHead = ({ page, name }) => {
  const location = useLocation();
  const tournamentSlug = useTournamentSlug();
  const seeded = prerenderTournamentForPath(location.pathname);
  const tournamentName = name || seeded?.tournament?.name || "Tournament";
  const meta = subpageMeta(page, tournamentName);
  if (!meta) return null;

  const tournament = seeded?.tournament;
  const structuredData = tournament
    ? generateTournamentStructuredData({
        ...tournament,
        slug: tournamentSlug || tournament.slug,
        locations: seeded.locations || [],
      })
    : undefined;

  return (
    <SEOHead
      title={meta.title}
      description={meta.description}
      canonicalUrl={tournamentPath(tournamentSlug, `/${page}`)}
      structuredData={structuredData}
    />
  );
};

export default TournamentSubpageHead;
